/* Progressive enhancement only. Questions are submitted by Shopify's native contact form.
   Health questions and email addresses are never written to browser storage. */
(() => {
  'use strict';
  if (window.imhHealthQaLoaded) return;
  window.imhHealthQaLoaded = true;
  const normalize = (value) => String(value || '').normalize('NFKC').toLocaleLowerCase('ko').replace(/\s+/g, ' ').trim();
  function init(scope) {
    scope.querySelectorAll('[data-qa-board]').forEach((board) => {
      if (board.dataset.qaReady) return;
      board.dataset.qaReady = 'true';
      const query = board.querySelector('[data-qa-query]');
      const status = board.querySelector('[data-qa-status-filter]');
      const rows = Array.from(board.querySelectorAll('[data-qa-row]'));
      const count = board.querySelector('[data-qa-results]');
      const empty = board.querySelector('[data-qa-no-results]');
      if (!query || !status) return;
      const update = () => {
        const words = normalize(query.value).split(' ').filter(Boolean);
        let matches = 0;
        rows.forEach((row) => {
          const visible = words.every((word) => normalize(row.dataset.search).includes(word)) && (status.value === 'all' || row.dataset.status === status.value);
          row.hidden = !visible;
          if (visible) matches += 1;
        });
        if (count) count.textContent = `현재 페이지 ${rows.length}건 중 ${matches}건 표시`;
        if (empty) empty.hidden = matches !== 0 || rows.length === 0;
      };
      query.disabled = false;
      status.disabled = false;
      query.addEventListener('input', update);
      status.addEventListener('change', update);
      update();
    });
    scope.querySelectorAll('[data-qa-question]').forEach((section) => {
      if (section.dataset.qaReady) return;
      section.dataset.qaReady = 'true';
      const body = section.querySelector('[data-qa-body]');
      const count = section.querySelector('[data-qa-char-count]');
      if (body && count) {
        const update = () => { count.textContent = `${body.value.length.toLocaleString('ko')} / 5,000`; };
        count.hidden = false;
        body.addEventListener('input', update);
        update();
      }
      const feedback = section.querySelector('[data-qa-feedback]');
      if (feedback) feedback.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
